export default __webpack_public_path__ + "static/media/Party_Cups.1187459d.png";